import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Tooltip as MuiTooltip } from '@mui/material';
import React, { CSSProperties, useState } from 'react';
import { CustomImageHandler } from './components/CustomImageHandler';
import { IBrandCollaborations } from '../model/shared/ICollaboration';

interface IAssignedUserTooltipProps {
    brands?: IBrandCollaborations[];
    numberVisibleBrands: number;
    styleSpan?: CSSProperties;
}

export function BrandCollaborationTooltip({
    brands,
    numberVisibleBrands = 3,
    styleSpan = { width: 33 },
}: IAssignedUserTooltipProps) {
    const [openTooltip, setOpenTooltip] = useState(false);

    return (
        <>
            {(brands?.length ?? 0) > numberVisibleBrands && (
                <ClickAwayListener onClickAway={() => setOpenTooltip(false)}>
                    <MuiTooltip
                        id="white-tooltip-sm"
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        PopperProps={{
                            disablePortal: true,
                        }}
                        onClose={() => setOpenTooltip(false)}
                        open={openTooltip}
                        title={
                            <>
                                {brands?.slice(numberVisibleBrands)?.map(item => (
                                    <div className="mx-1 my-2" key={item?.id}>
                                        <div className="d-flex align-items-center">
                                            <CustomImageHandler
                                                classes="user-img-rounded"
                                                photoPath={item?.logoUrl ?? '/icons/UserPlaceholder.png'}
                                                altTag={`${item?.name}`}
                                            />
                                            <h6 className="ml-1 text-dark mb-0">{item?.name}</h6>
                                        </div>
                                    </div>
                                ))}
                            </>
                        }
                        placement="right-end"
                        className="cursor-pointer "
                    >
                        <span
                            onClick={() => setOpenTooltip(prevState => !prevState)}
                            className="icon-round bg-white text-primary shadow font-weight-semi-bold min-width-max-content cursor-pointer"
                            style={styleSpan}
                        >
                            + {(brands?.length ?? 0) - numberVisibleBrands}
                        </span>
                    </MuiTooltip>
                </ClickAwayListener>
            )}
        </>
    );
}
